import React from "react";
import { array, bool, func, object, oneOf, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import { flatten } from "lodash";

import Loadericon from "../load-more-button-loader/index";
import Anchor from "../Anchor";

import { getSlug, validURL } from "../../utils/utils";

import { MICROSITES_OLD_URLS } from "../../../../server/helpers/constants";

import "./more.m.css";

const More = ({ collection, type, onClick, text, sections, showButtonSpinner = false, domainSlug }) => {
  if (type === "read-more") {
    const { navigate_to: navigateTo } = collection["associated-metadata"] || {};

    const collectionSlug = getSlug(collection, sections, domainSlug, navigateTo);

    const genCollectionSlug = () => {
      if (validURL(collectionSlug)) return collectionSlug;

      const flattenedUrls = flatten(MICROSITES_OLD_URLS);
      const slugIndex = flattenedUrls.indexOf(collectionSlug);
      return slugIndex >= 0 ? flattenedUrls[slugIndex + 1] : collectionSlug;
    };

    const url = genCollectionSlug();

    return (
      <Anchor aria-label={text} href={url} styleName="wrapper" className="more">
        <span styleName="content" className="content">
          {text}
        </span>
      </Anchor>
    );
  } else {
    return (
      <div styleName="wrapper" className="more" onClick={onClick}>
        <span styleName="content" className="load-more-content">
          {text}
          {showButtonSpinner && <Loadericon />}
        </span>
      </div>
    );
  }
};

More.defaultProps = {
  type: "read-more",
  text: "Read More",
};

const mapStateToProps = (state) => ({
  sections: get(state, ["qt", "config", "sections"], []),
  domainSlug: get(state, ["qt", "config", "domainSlug"], ""),
});

More.propTypes = {
  sections: array,
  text: string,
  collection: object,
  onClick: func,
  type: oneOf(["read-more", "load-more"]),
  showButtonSpinner: bool,
  domainSlug: string,
};

export default connect(mapStateToProps)(More);
